import React from 'react';
import { Lap } from '../../models/IRider';
import { TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
    table: {
        tableLayout: 'auto'
    },
    bestLap: {
        background: `linear-gradient(45deg, ${theme.palette.primary.dark} 30%, ${theme.palette.primary.light} 90%)`,
        border: 0,
        borderRadius: 3,
        boxShadow: '0 3px 5px 2px rgba(0, 0, 0, .3)',
        color: theme.palette.primary.contrastText,
        height: 48,
        padding: '0 30px',
    },
}));

interface IParticipantLapsProps {
    laps: Lap[];
    idBestLap: number;
}

function ParticipantLaps(props: IParticipantLapsProps) {
    const { laps, idBestLap } = props;
    const { t } = useTranslation("common");
    const classes = useStyles();

    console.debug(`laps: ${laps.length}`);

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="rider results" width="100%">
                <TableHead>
                    <TableRow>
                        <TableCell align="right" width="20%" >{t("rider.lap")}</TableCell>
                        <TableCell align="right" width="40%" >{t("rider.lapTime")}</TableCell>
                        <TableCell align="right" width="40%">{t("rider.seen")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {laps.map((lap) => (
                        <TableRow key={lap.lapId} className={lap.lapId===idBestLap ? classes.bestLap : undefined} >
                            <TableCell component="th" scope="row" align="right" width="20%" >
                                {lap.lapId}
                            </TableCell>
                            <TableCell align="right" width="40%" >{lap.timeFormatted}</TableCell>
                            <TableCell align="right" width="40%">{lap.readFormatted}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>);
}

export default ParticipantLaps;